import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { formatRupees } from '../../utils/transactionAnalysis';

// Shared pieces for the Analysis charts (Transactions and Investments tabs)

export const GRID = '#e5e7eb';
export const chartSx = {
  '& .MuiChartsAxis-line, & .MuiChartsAxis-tick': { stroke: GRID },
  '& .MuiChartsAxis-tickLabel': { fill: '#64748b', fontSize: 12 },
  '& .MuiChartsGrid-line': { stroke: GRID, strokeWidth: 1 },
  // 2px surface gap between touching marks (stacked segments, grouped bars)
  '& .MuiBarElement-root': { stroke: '#ffffff', strokeWidth: 2 },
};
export const money = (value) => (value === null ? '' : formatRupees(value));

// HTML legend (wraps on phones, unlike the chart's built-in one)
export const Legend = ({ items }) => (
  <Box component="ul" sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px 16px', listStyle: 'none', p: 0, m: 0, mb: 1 }}>
    {items.map(item => (
      <Box component="li" key={item.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.75, fontSize: 13, color: 'text.secondary' }}>
        <Box sx={{ width: 10, height: 10, borderRadius: '3px', bgcolor: item.color, flexShrink: 0 }} />
        {item.label}
      </Box>
    ))}
  </Box>
);

export const ChartCard = ({ title, subtitle, children, ...props }) => (
  <Paper sx={{ p: { xs: 1.5, sm: 2.5 }, mb: 3, minWidth: 0 }} {...props}>
    <Typography variant="h6" sx={{ fontWeight: 700 }}>{title}</Typography>
    {subtitle && <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>{subtitle}</Typography>}
    {children}
  </Paper>
);

